import React from 'react';
import { Navigate } from 'react-router-dom';
import { PrivateRoute } from '../PrivateRoute';
import Login from '../Login';
import EventsPage from '../EventsPage/Loadable';
import InternalUser from '../InternalUser/Loadable';
import EventsPageManager from '../../managers/EventsPageManager';
import InternalUserManager from '../../managers/InternalUserManager';
import EventDetailManager from '../../managers/EventDetailManager';
import EventDetail from '../EventDetail/Loadable';
import EventPage from '../EventPage/Loadable';
import EventGroup from '../EventGroup/Loadable';
import EventTeamListManager from '../../managers/EventTeamListManager';
import EventVolunteerListManager from '../../managers/EventVolunteerListManager';
import EventTeamDetailManager from '../../managers/EventTeamDetailManager';
import EventTeamDetail from '../EventTeamDetail/Loadable';
import VolunteerDetailManager from '../../managers/VolunteerDetailManager';
import VolunteerDetail from '../VolunteerDetail/Loadable';
import VolunteerTagsManager from '../../managers/VolunteerTagsManager';
import VolunteerTags from '../VolunteerTags/Loadable';
import TeamTags from '../TeamTags/Loadable';
import MemberTags from '../MemberTags/Loadable';
import VolunteerGroupsManager from '../../managers/VolunteerGroupsManager';
import VolunteerGroups from '../VolunteerGroups/Loadable';
import MemberDetailManager from '../../managers/MemberDetailManager';
import TeamTagsManager from '../../managers/TeamTagsManager';
import MemberTagsManager from '../../managers/MemberTagsManager';
import MemberDetail from '../MemberDetail/Loadable';
import EventMemberListManager from '../../managers/EventMemberListManager';
import SupporterListPage from '../SupporterListPage/Loadable';
import SupporterListManager from '../../managers/SupporterListManager';
import SupporterDetailManager from '../../managers/SupporterDetailManager';
import SupporterDetail from '../SupporterDetail/Loadable';
import AdminDashboardManager from '../../managers/AdminDashboardManager';
import AdminDashboard from '../AdminDashboard/Loadable';
import EventGlobalSetting from '../EventGlobalSetting/Loadable';
import RoleBasedRoute from '../RoleBasedRoute';
import ModuleBasedRoute from '../ModuleBasedRoute';
import SyncJobListManager from '../../managers/SyncJobListManager';
import SyncJobList from '../SyncJobList/Loadable';
import EventGroupManager from '../../managers/EventGroupManager';
import EventGroupDetailManager from '../../managers/EventGroupDetailManager';
import EventGroupPage from '../EventGroupPage/Loadable';
import EventGroupStatistic from '../EventGroupStatistic/Loadable';
import MemberListPage from '../MemberListPage/Loadable';
import TeamListPage from '../TeamListPage/Loadable';
import VolunteerListPage from '../VolunteerListPage/Loadable';

const VOLUNTEER_MODULE = 'Volunteer';
const SUPPORTER_MODULE = 'Supporter';

const DEFAULT_ROUTE = process.env.REACT_APP_LANDING_URL || '/events/active';

const routes = [
  {
    path: '/login',
    id: 'login',
    element: <Login />,
  },
  {
    path: '/forgot-password',
    id: 'forgot-password',
    element: <h1>Forgot password</h1>,
  },
  {
    path: '/*',
    id: 'private-route',
    element: <PrivateRoute />,
    children: [
      {
        path: 'event-groups/:status',
        element: (
          <EventGroupManager>
            <EventGroup></EventGroup>
          </EventGroupManager>
        ),
      },
      {
        path: 'events/:status',
        element: (
          <EventsPageManager>
            <EventsPage></EventsPage>
          </EventsPageManager>
        ),
      },
      {
        path: 'event-group/:id',
        element: (
          <EventGroupDetailManager>
            <EventGroupPage></EventGroupPage>
          </EventGroupDetailManager>
        ),
        children: [
          {
            path: '',
            element: <RoleBasedRoute roles={[1, 2]}></RoleBasedRoute>,
            children: [
              {
                path: 'detail',
                element: <EventGroupStatistic></EventGroupStatistic>,
              },
              {
                path: 'teams',
                element: (
                  <EventTeamListManager>
                    <TeamListPage></TeamListPage>
                  </EventTeamListManager>
                ),
              },
              {
                path: 'volunteers',
                element: (
                  <ModuleBasedRoute
                    module={VOLUNTEER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    id: 'event-group.volunteerlist',
                    element: (
                      <EventVolunteerListManager>
                        <VolunteerGroupsManager>
                          <VolunteerListPage></VolunteerListPage>
                        </VolunteerGroupsManager>
                      </EventVolunteerListManager>
                    ),
                  },
                ],
              },
              // routes specific to each event
              {
                path: 'events/:eventId',
                element: (
                  <EventDetailManager>
                    <EventPage></EventPage>
                  </EventDetailManager>
                ),
                children: [
                  {
                    path: 'detail',
                    element: <EventDetail></EventDetail>,
                  },
                  {
                    path: 'teams',
                    id: 'event-group.event.teamlist',
                    element: (
                      <EventTeamListManager>
                        <TeamListPage></TeamListPage>
                      </EventTeamListManager>
                    ),
                  },
                  {
                    path: 'volunteers',
                    element: (
                      <ModuleBasedRoute
                        module={VOLUNTEER_MODULE}
                      ></ModuleBasedRoute>
                    ),
                    children: [
                      {
                        path: '',
                        element: (
                          <EventVolunteerListManager>
                            <VolunteerGroupsManager>
                              <VolunteerListPage></VolunteerListPage>
                            </VolunteerGroupsManager>
                          </EventVolunteerListManager>
                        ),
                      },
                    ],
                  },
                  {
                    path: 'members',
                    element: (
                      <EventMemberListManager>
                        <MemberListPage></MemberListPage>
                      </EventMemberListManager>
                    ),
                  },
                  {
                    path: 'supporters',
                    element: (
                      <ModuleBasedRoute
                        module={SUPPORTER_MODULE}
                      ></ModuleBasedRoute>
                    ),
                    children: [
                      {
                        path: '',
                        element: (
                          <SupporterListManager>
                            <SupporterListPage></SupporterListPage>
                          </SupporterListManager>
                        ),
                      },
                    ],
                  },
                  {
                    path: 'teams/:teamId',
                    element: (
                      <EventTeamDetailManager>
                        <InternalUserManager>
                          <EventTeamListManager>
                            <EventTeamDetail></EventTeamDetail>
                          </EventTeamListManager>
                        </InternalUserManager>
                      </EventTeamDetailManager>
                    ),
                  },
                  {
                    path: 'volunteers/:volunteerId',
                    element: (
                      <ModuleBasedRoute
                        module={VOLUNTEER_MODULE}
                      ></ModuleBasedRoute>
                    ),
                    children: [
                      {
                        path: '',
                        element: (
                          <VolunteerDetailManager>
                            <VolunteerGroupsManager>
                              <InternalUserManager>
                                <EventVolunteerListManager>
                                  <VolunteerDetail></VolunteerDetail>
                                </EventVolunteerListManager>
                              </InternalUserManager>
                            </VolunteerGroupsManager>
                          </VolunteerDetailManager>
                        ),
                      },
                    ],
                  },
                  {
                    path: 'supporters/:supporterId',
                    element: (
                      <ModuleBasedRoute
                        module={SUPPORTER_MODULE}
                      ></ModuleBasedRoute>
                    ),
                    children: [
                      {
                        path: '',
                        element: (
                          <SupporterDetailManager>
                            <SupporterListManager>
                              <SupporterDetail></SupporterDetail>
                            </SupporterListManager>
                          </SupporterDetailManager>
                        ),
                      },
                    ],
                  },
                  {
                    path: 'members/:memberId',
                    element: (
                      <MemberDetailManager>
                        <EventMemberListManager>
                          <MemberDetail></MemberDetail>
                        </EventMemberListManager>
                      </MemberDetailManager>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: 'members',
            id: 'member-onboarder',
            element: <RoleBasedRoute roles={[1, 2, 3, 4]}></RoleBasedRoute>,
            children: [
              {
                path: '',
                id: 'event-group.memberlisting',
                element: (
                  <EventMemberListManager>
                    <MemberListPage></MemberListPage>
                  </EventMemberListManager>
                ),
              },
            ],
          },
          {
            path: 'supporters',
            id: 'event-group.supporter-onboarder',
            element: <RoleBasedRoute roles={[1, 2, 3, 5]}></RoleBasedRoute>,
            children: [
              {
                path: '',
                id: 'event.supporterlist.module',
                element: (
                  <ModuleBasedRoute
                    module={SUPPORTER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    id: 'event-group.suporterList',
                    element: (
                      <SupporterListManager>
                        <SupporterListPage></SupporterListPage>
                      </SupporterListManager>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: 'setting',
            element: <RoleBasedRoute roles={[1, 2]}></RoleBasedRoute>,
            children: [
              {
                path: 'team-tags',
                element: (
                  <TeamTagsManager>
                    <TeamTags></TeamTags>
                  </TeamTagsManager>
                ),
              },
              {
                path: 'member-tags',
                element: (
                  <MemberTagsManager>
                    <MemberTags></MemberTags>
                  </MemberTagsManager>
                ),
              },
              {
                path: '',
                element: (
                  <ModuleBasedRoute
                    module={VOLUNTEER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: 'volunteer-tags',
                    element: (
                      <VolunteerTagsManager>
                        <VolunteerTags></VolunteerTags>
                      </VolunteerTagsManager>
                    ),
                  },
                  {
                    path: 'volunteer-groups',
                    element: (
                      <VolunteerGroupsManager>
                        <VolunteerGroups></VolunteerGroups>
                      </VolunteerGroupsManager>
                    ),
                  },
                ],
              },
              {
                path: 'global-setting',
                element: <EventGlobalSetting></EventGlobalSetting>,
              },
            ],
          },
          {
            path: '*',
            element: <Navigate replace to="/event-groups/active" />,
          },
        ],
      },
      {
        path: 'event/:id',
        element: (
          <EventDetailManager>
            <EventPage></EventPage>
          </EventDetailManager>
        ),
        children: [
          {
            path: '',
            element: <RoleBasedRoute roles={[1, 2]}></RoleBasedRoute>,
            children: [
              {
                path: 'detail',
                element: <EventDetail></EventDetail>,
              },
              {
                path: 'teams',
                element: (
                  <EventTeamListManager>
                    <TeamListPage></TeamListPage>
                  </EventTeamListManager>
                ),
              },
              {
                path: 'volunteers',
                element: (
                  <ModuleBasedRoute
                    module={VOLUNTEER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    element: (
                      <EventVolunteerListManager>
                        <VolunteerGroupsManager>
                          <VolunteerListPage></VolunteerListPage>
                        </VolunteerGroupsManager>
                      </EventVolunteerListManager>
                    ),
                  },
                ],
              },
              {
                path: 'teams/:teamId',
                element: (
                  <EventTeamDetailManager>
                    <InternalUserManager>
                      <EventTeamListManager>
                        <EventTeamDetail></EventTeamDetail>
                      </EventTeamListManager>
                    </InternalUserManager>
                  </EventTeamDetailManager>
                ),
              },
              {
                path: 'volunteers/:volunteerId',
                element: (
                  <ModuleBasedRoute
                    module={VOLUNTEER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    id: 'event.volunteer.detail',
                    element: (
                      <VolunteerDetailManager>
                        <VolunteerGroupsManager>
                          <InternalUserManager>
                            <EventVolunteerListManager>
                              <VolunteerDetail></VolunteerDetail>
                            </EventVolunteerListManager>
                          </InternalUserManager>
                        </VolunteerGroupsManager>
                      </VolunteerDetailManager>
                    ),
                  },
                ],
              },
              {
                path: 'supporters/:supporterId',
                element: (
                  <ModuleBasedRoute
                    module={SUPPORTER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    element: (
                      <SupporterDetailManager>
                        <SupporterListManager>
                          <SupporterDetail></SupporterDetail>
                        </SupporterListManager>
                      </SupporterDetailManager>
                    ),
                  },
                ],
              },
              {
                path: 'members/:memberId',
                element: (
                  <MemberDetailManager>
                    <EventMemberListManager>
                      <MemberDetail></MemberDetail>
                    </EventMemberListManager>
                  </MemberDetailManager>
                ),
              },
            ],
          },
          {
            path: 'members',
            element: <RoleBasedRoute roles={[1, 2, 3, 4]}></RoleBasedRoute>,
            children: [
              {
                path: '',
                element: (
                  <EventMemberListManager>
                    <MemberListPage></MemberListPage>
                  </EventMemberListManager>
                ),
              },
            ],
          },
          {
            path: 'supporters',
            element: <RoleBasedRoute roles={[1, 2, 3, 5]}></RoleBasedRoute>,
            children: [
              {
                path: '',
                element: (
                  <ModuleBasedRoute
                    module={SUPPORTER_MODULE}
                  ></ModuleBasedRoute>
                ),
                children: [
                  {
                    path: '',
                    element: (
                      <SupporterListManager>
                        <SupporterListPage></SupporterListPage>
                      </SupporterListManager>
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: '*',
            element: <Navigate replace to="/events/active" />,
          },
        ],
      },
      {
        path: 'users/:id',
        element: (
          <InternalUserManager>
            <InternalUser></InternalUser>
          </InternalUserManager>
        ),
      },
      {
        path: 'admin',
        element: <RoleBasedRoute roles={[1]}></RoleBasedRoute>,
        children: [
          {
            path: '',
            element: (
              <AdminDashboardManager>
                <AdminDashboard></AdminDashboard>
              </AdminDashboardManager>
            ),
          },
          {
            path: 'sync-jobs',
            element: (
              <SyncJobListManager>
                <SyncJobList></SyncJobList>
              </SyncJobListManager>
            ),
          },
        ],
      },
      {
        path: '*',
        element: <Navigate replace to={DEFAULT_ROUTE} />,
      },
    ],
  },
];

export default routes;
